var _a, _b;
import { FlagAlb, FlagArg, FlagAut, FlagBgr, FlagBih, FlagBra, FlagCiv, FlagCze, FlagDeu, FlagDnk, FlagEng, FlagFin, FlagFra, FlagGab, FlagGha, FlagHrv, FlagHun, FlagIrl, FlagIsr, FlagJpn, FlagLtu, FlagMda, FlagMkd, FlagMne, FlagNga, FlagNld, FlagPol, FlagPrt, FlagRou, FlagSrb, FlagSvn, FlagSwe, FlagTur, FlagUry, FlagXkx, } from "./index";
/**
 * Display name is full name, value is ISO 3166-1 alpha-3 code
 */
export var ENationality;
(function (ENationality) {
    ENationality["ANTARCTICA"] = "ATA";
    ENationality["ENGLAND"] = "ENG";
    ENationality["ARGENTINA"] = "ARG";
    ENationality["AUSTRIA"] = "AUT";
    ENationality["BOSNIA_AND_HERZEGOVINA"] = "BIH";
    ENationality["DENMARK"] = "DNK";
    ENationality["FRANCE"] = "FRA";
    ENationality["GABON"] = "GAB";
    ENationality["GHANA"] = "GHA";
    ENationality["CROATIA"] = "HRV";
    ENationality["JAPAN"] = "JPN";
    ENationality["KOSOVO"] = "XKX";
    ENationality["LITHUANIA"] = "LTU";
    ENationality["MACEDONIA"] = "MKD";
    ENationality["HUNGARY"] = "HUN";
    ENationality["MONTENEGRO"] = "MNE";
    ENationality["NIGERIA"] = "NGA";
    ENationality["POLAND"] = "POL";
    ENationality["NETHERLANDS"] = "NLD";
    ENationality["SLOVENIA"] = "SVN";
    ENationality["COTE_D_IVOIRE"] = "CIV";
    ENationality["SERBIA"] = "SRB";
    ENationality["SWEDEN"] = "SWE";
    ENationality["PORTUGAL"] = "PRT";
    ENationality["ALBANIA"] = "ALB";
    ENationality["BULGARIA"] = "BGR";
    ENationality["BRAZIL"] = "BRA";
    ENationality["CZECH_REPUBLIC"] = "CZE";
    ENationality["FINLAND"] = "FIN";
    ENationality["ISRAEL"] = "ISR";
    ENationality["MOLDOVA"] = "MDA";
    ENationality["GERMANY"] = "DEU";
    ENationality["ROMANIA"] = "ROU";
    ENationality["URUGUAY"] = "URY";
    ENationality["TURKEY"] = "TUR";
    ENationality["IRELAND"] = "IRL";
})(ENationality || (ENationality = {}));
export var nationalityToFlagMap = (_a = {},
    _a[ENationality.ENGLAND] = FlagEng,
    _a[ENationality.ARGENTINA] = FlagArg,
    _a[ENationality.AUSTRIA] = FlagAut,
    _a[ENationality.BOSNIA_AND_HERZEGOVINA] = FlagBih,
    _a[ENationality.DENMARK] = FlagDnk,
    _a[ENationality.FRANCE] = FlagFra,
    _a[ENationality.GABON] = FlagGab,
    _a[ENationality.GHANA] = FlagGha,
    _a[ENationality.CROATIA] = FlagHrv,
    _a[ENationality.JAPAN] = FlagJpn,
    _a[ENationality.KOSOVO] = FlagXkx,
    _a[ENationality.LITHUANIA] = FlagLtu,
    _a[ENationality.MACEDONIA] = FlagMkd,
    _a[ENationality.HUNGARY] = FlagHun,
    _a[ENationality.MONTENEGRO] = FlagMne,
    _a[ENationality.NETHERLANDS] = FlagNld,
    _a[ENationality.NIGERIA] = FlagNga,
    _a[ENationality.POLAND] = FlagPol,
    _a[ENationality.SLOVENIA] = FlagSvn,
    _a[ENationality.COTE_D_IVOIRE] = FlagCiv,
    _a[ENationality.SERBIA] = FlagSrb,
    _a[ENationality.SWEDEN] = FlagSwe,
    _a[ENationality.PORTUGAL] = FlagPrt,
    _a[ENationality.ALBANIA] = FlagAlb,
    _a[ENationality.BULGARIA] = FlagBgr,
    _a[ENationality.BRAZIL] = FlagBra,
    _a[ENationality.CZECH_REPUBLIC] = FlagCze,
    _a[ENationality.FINLAND] = FlagFin,
    _a[ENationality.ISRAEL] = FlagIsr,
    _a[ENationality.MOLDOVA] = FlagMda,
    _a[ENationality.GERMANY] = FlagDeu,
    _a[ENationality.ROMANIA] = FlagRou,
    _a[ENationality.URUGUAY] = FlagUry,
    _a[ENationality.TURKEY] = FlagTur,
    _a[ENationality.IRELAND] = FlagIrl,
    _a);
export var nationalityToSloveneShorthandMap = (_b = {},
    _b[ENationality.ENGLAND] = "ENG",
    _b[ENationality.ARGENTINA] = "ARG",
    _b[ENationality.AUSTRIA] = "AUT",
    _b[ENationality.BOSNIA_AND_HERZEGOVINA] = "BIH",
    _b[ENationality.DENMARK] = "DEN",
    _b[ENationality.FRANCE] = "FRA",
    _b[ENationality.GABON] = "GAB",
    _b[ENationality.GHANA] = "GHA",
    _b[ENationality.CROATIA] = "CRO",
    _b[ENationality.JAPAN] = "JPN",
    _b[ENationality.KOSOVO] = "XKX",
    _b[ENationality.LITHUANIA] = "LTU",
    _b[ENationality.MACEDONIA] = "MKD",
    _b[ENationality.HUNGARY] = "HUN",
    _b[ENationality.MONTENEGRO] = "MNE",
    _b[ENationality.NETHERLANDS] = "NED",
    _b[ENationality.NIGERIA] = "NGA",
    _b[ENationality.POLAND] = "POL",
    _b[ENationality.SLOVENIA] = "SLO",
    _b[ENationality.COTE_D_IVOIRE] = "CIV",
    _b[ENationality.SERBIA] = "SRB",
    _b[ENationality.SWEDEN] = "SWE",
    _b[ENationality.PORTUGAL] = "POR",
    _b[ENationality.ALBANIA] = "ALB",
    _b[ENationality.BULGARIA] = "BUL",
    _b[ENationality.BRAZIL] = "BRA",
    _b[ENationality.CZECH_REPUBLIC] = "CZE",
    _b[ENationality.FINLAND] = "FIN",
    _b[ENationality.ISRAEL] = "ISR",
    _b[ENationality.MOLDOVA] = "MDA",
    _b[ENationality.GERMANY] = "GER",
    _b[ENationality.ROMANIA] = "ROU",
    _b[ENationality.URUGUAY] = "URU",
    _b[ENationality.TURKEY] = "TUR",
    _b[ENationality.ANTARCTICA] = "ANT",
    _b[ENationality.IRELAND] = "IRS",
    _b);
